import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LayoutService } from './service/app.layout.service';
import { UserAdService } from '../main/service/user-ad.service';

interface Breadcrumb {
    label: string;
    url?: string;
    fragment?: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html'
})
export class AppBreadcrumbComponent {

    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();
    @ViewChild('searchinput') searchInput!: ElementRef;
    searchActive: boolean = false;

    userAD: any;

    constructor(
        private router: Router,
        private _userAd: UserAdService,
        public layoutService: LayoutService
    ) {
        this._userAd.connectedUserAD$.subscribe(
            (userLoggedIn: any) => {
                this.userAD = userLoggedIn;
            }
        );
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(event => {
            const root = this.router.routerState.snapshot.root;
            const breadcrumbs: Breadcrumb[] = [];
            this.addBreadcrumb(root, [], breadcrumbs);

            this._breadcrumbs$.next(breadcrumbs);
        });
    }

    width(ssn: string) {
        let _width: any;
        switch (ssn) {
            case 'ZEN': _width = '90px'; break;
            case 'TTD': _width = '115px'; break;
            case 'HA': _width = '65px'; break;
            case 'EXIST': _width = '106px'; break;
            case 'Sotufab': _width = '104px'; break;
            case 'Tunisie Booking': _width = '115px'; break;
        }
        return _width;
    }

    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }

    deactivateSearch() {
        this.searchActive = false;
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    onSidebarButtonClick() {
        this.layoutService.showSidebar();
    }

    private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        const routeUrl = parentUrl.concat(route.url.map(url => url.path));
        const breadcrumb = route.data['breadcrumb'];
        const parentBreadcrumb = route.parent && route.parent.data ? route.parent.data['breadcrumb'] : null;

        if (breadcrumb && breadcrumb !== parentBreadcrumb) {
            breadcrumbs.push({
                label: route.data['breadcrumb'],
                fragment: route.data['fragment'],
                url: '/' + routeUrl.join('/')
            });
        }

        if (route.firstChild) {
            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }

}
